import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { TranslationService } from './translation.service';


const ENABLED_PATH = [
  'coming-soon',
  'login',
  '/stories/anonymize',
  '/stories/link-participant',
  '/stories/processing',
  '/stories/verify',
  'my-race-details',
  '/stories/experience',
  '/stories/register',
];
const NON_PRODUCTION_PATH = '/stories';

@Injectable({
  providedIn: 'root'
})
export class ProdEnabledGuard implements CanActivate {
  constructor(private readonly router: Router, private readonly translationService: TranslationService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const featureFlags = this.translationService.featureFlags;
    const isMyStoriesVisible = featureFlags.circuitDetails.enableStories;

    if (!environment.production) {
      return true;
    } else if (ENABLED_PATH.some(path => state.url.includes(path))) {
      return true;
    } else {
      if (state.url.includes(NON_PRODUCTION_PATH) && isMyStoriesVisible) {
        return true;
      }
      this.router.navigateByUrl('coming-soon');
      return false;
    }
  }
}
